import React from "react";
import { BookingEventType, EventLog_BookingEventFragment } from "@graphql";
import { Link } from "@material-ui/core";
import { OpenInNew } from "@material-ui/icons";
import { Paragraph } from "@components/typography/Paragraph";
import { Event } from "../../Event/Event";
import { BookingEventFloatingMenu } from "../BookingEventFloatingMenu/BookingEventFloatingMenu";
import { InlineEditor } from "@components/InlineEditor/InlineEditor";
import { BookingEventLogStore } from "../BookingEventLogStore";
import locale from "@bonliva-crm/locale";
import Body from "@components/typography/Body";
import { StyledHtml } from "@common/StyledHtml";

type Props = {
  item: EventLog_BookingEventFragment;
  store: BookingEventLogStore;
};

export function BookingEvent(props: Props) {
  const [editing, setEditing] = React.useState(false);
  const { item } = props;

  const icon = eventTypeToIcon[item.Type]?.() ?? null;
  const menu = (
    <BookingEventFloatingMenu
      event={item}
      onEdit={() => setEditing(true)}
      onPin={props.store.handlePin}
      onDelete={props.store.deleteEvent}
    />
  );
  const description = item.Description;

  return item.Type !== BookingEventType.SystemLog ? (
    <Event item={item} icon={icon} floatingMenu={menu}>
      {description && (
        <InlineEditor
          readOnlyRenderer={() => <StyledHtml>{item.DescriptionHtml}</StyledHtml>}
          initialValue={description}
          isEditing={editing}
          onCancel={() => setEditing(false)}
          onSubmit={(text) =>
            props.store.updateEvent(item._id, text).then(() => setEditing(false))
          }
        />
      )}
    </Event>
  ) : (
    <Event item={item} icon={icon} floatingMenu={menu}>
      <Paragraph
        style={{
          display: "flex",
          alignItems: "center",
          minHeight: 30,
          lineHeight: 1
        }}
      >
        {!item.ResultOfAction ? (
          <StyledHtml styleProps={{ display: "inline-block" }}>
            {item.DescriptionHtml}
          </StyledHtml>
        ) : (
          <Body>
            {item.UserRef?.Name} - {locale.bookingSystemEvents[description]}{" "}
            {item.ResultOfAction && (
              <b>
                {locale.accommodationTravelStatus[item.ResultOfAction] ??
                  locale.bookingSystemEvents[item.ResultOfAction] ??
                  locale.bookingStatus[item.ResultOfAction] ??
                  item.ResultOfAction}
              </b>
            )}
          </Body>
        )}
        {item.Links &&
          item.Links.map((pdfUrl, i) => (
            <Link key={i} href={pdfUrl} target="_blank">
              <OpenInNew />
            </Link>
          ))}
      </Paragraph>
    </Event>
  );
}

const eventTypeToIcon: Record<BookingEventType, () => React.ReactNode | null> = {
  [BookingEventType.Comment]: () => null,
  [BookingEventType.SystemLog]: () => null
};
